export enum ProductTabs {
  DETAILS = "details",
}

export enum ProductDetailsFields {
  SKU = "sku",
  DESCRIPTION = "description",
  PROJECT = "projects",
  STATUS = "status",
  COMPANY = "company",
  PURCHASE_ORDERS = "purchaseOrders",
  CUSTOMER_ID = "customerId",
  CUSTOMER = "customer",
  SUPPLIER_ID = "supplierId",
  HS_CODE = "hscode",
  STYLE = "style",
  CUBIC_VOLUME = "cubicVolume",
  UNIT_PRICE = "unitPrice",
  TOTAL_PRICE = "totalPrice",
  CURRENCY = "currencyId",
  STOCK = "currentStock",
  IN_TRANSIT_QUANTITY = "inTransitQuantity",
  ORIGIN_SHIPMENTS = "originShipments",
  CARTONS_TO_DESPATCH = "cartonsToDespatch",
  LINING = "lining",
  FABRIC = "fabric",
  CONSTRUCTION = "construction",
  COMPOSITION = "composition",
  MANUFACTURE_DETAILS = "manufactureDetails",
  DETAILS = "details",
  GENDER = "gender",
  CARTON_QUANTITIES = "cartonQuantities",

  // Dimensions
  WIDTH = "width",
  HEIGHT = "height",
  LENGTH = "length",
  WEIGHT = "weight",
  CARTON_WEIGHT = "cartonWeight",
  // Palette Dimensions

  CARTONS_PER_PALETT = "ctnPerPallet",
  PALLET_HIGHT = "palletHeight",
  TIE = "tie",
  HIGH = "high",

  PICTURE = "picture",
}

export type ProductFields = ProductDetailsFields;
